'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themer = require('../../../../themer');

var _memoizeClassName = require('../utils/memoizeClassName');

var _memoizeClassName2 = _interopRequireDefault(_memoizeClassName);

var _scales = require('../foundational-styles/scales');

var _scales2 = _interopRequireDefault(_scales);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Appearances = {};

Appearances.default = _themer.Themer.createTableCellAppearance({
  focus: {
    outline: 'none',
    backgroundColor: _scales2.default.primary.P2A,
    boxShadow: 'inset 0 0 0 1px ' + _scales2.default.primary.P7A
  }
});

/**
 * Get the appearance of a `TableCell`.
 * @param {string} appearance
 * @return {string} the appearance object.
 */
var getAppearance = function getAppearance() {
  return Appearances.default;
};

/**
 * Get the className of a `Table.EditableCell`.
 * @param {string} appearance
 * @return {string} the appearance class name.
 */
exports.default = (0, _memoizeClassName2.default)(getAppearance);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvZGVmYXVsdC10aGVtZS9jb21wb25lbnQtc3BlY2lmaWMvZ2V0VGFibGVDZWxsQ2xhc3NOYW1lLmpzIl0sIm5hbWVzIjpbIkFwcGVhcmFuY2VzIiwiZGVmYXVsdCIsIlRoZW1lciIsImNyZWF0ZVRhYmxlQ2VsbEFwcGVhcmFuY2UiLCJmb2N1cyIsIm91dGxpbmUiLCJiYWNrZ3JvdW5kQ29sb3IiLCJzY2FsZXMiLCJwcmltYXJ5IiwiUDJBIiwiYm94U2hhZG93IiwiUDdBIiwiZ2V0QXBwZWFyYW5jZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7O0FBQ0E7Ozs7QUFDQTs7Ozs7O0FBRUEsSUFBTUEsY0FBYyxFQUFwQjs7QUFFQUEsWUFBWUMsT0FBWixHQUFzQkMsZUFBT0MseUJBQVAsQ0FBaUM7QUFDckRDLFNBQU87QUFDTEMsYUFBUyxNQURKO0FBRUxDLHFCQUFpQkMsaUJBQU9DLE9BQVAsQ0FBZUMsR0FGM0I7QUFHTEMsb0NBQThCSCxpQkFBT0MsT0FBUCxDQUFlRztBQUh4QztBQUQ4QyxDQUFqQyxDQUF0Qjs7QUFRQTs7Ozs7QUFLQSxJQUFNQyxnQkFBZ0IsU0FBaEJBLGFBQWdCLEdBQU07QUFDMUIsU0FBT1osWUFBWUMsT0FBbkI7QUFDRCxDQUZEOztBQUlBOzs7OztrQkFLZSxnQ0FBaUJXLGFBQWpCLEMiLCJmaWxlIjoiZ2V0VGFibGVDZWxsQ2xhc3NOYW1lLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgVGhlbWVyIH0gZnJvbSAnLi4vLi4vLi4vLi4vdGhlbWVyJ1xuaW1wb3J0IG1lbW9pemVDbGFzc05hbWUgZnJvbSAnLi4vdXRpbHMvbWVtb2l6ZUNsYXNzTmFtZSdcbmltcG9ydCBzY2FsZXMgZnJvbSAnLi4vZm91bmRhdGlvbmFsLXN0eWxlcy9zY2FsZXMnXG5cbmNvbnN0IEFwcGVhcmFuY2VzID0ge31cblxuQXBwZWFyYW5jZXMuZGVmYXVsdCA9IFRoZW1lci5jcmVhdGVUYWJsZUNlbGxBcHBlYXJhbmNlKHtcbiAgZm9jdXM6IHtcbiAgICBvdXRsaW5lOiAnbm9uZScsXG4gICAgYmFja2dyb3VuZENvbG9yOiBzY2FsZXMucHJpbWFyeS5QMkEsXG4gICAgYm94U2hhZG93OiBgaW5zZXQgMCAwIDAgMXB4ICR7c2NhbGVzLnByaW1hcnkuUDdBfWBcbiAgfVxufSlcblxuLyoqXG4gKiBHZXQgdGhlIGFwcGVhcmFuY2Ugb2YgYSBgVGFibGVDZWxsYC5cbiAqIEBwYXJhbSB7c3RyaW5nfSBhcHBlYXJhbmNlXG4gKiBAcmV0dXJuIHtzdHJpbmd9IHRoZSBhcHBlYXJhbmNlIG9iamVjdC5cbiAqL1xuY29uc3QgZ2V0QXBwZWFyYW5jZSA9ICgpID0+IHtcbiAgcmV0dXJuIEFwcGVhcmFuY2VzLmRlZmF1bHRcbn1cblxuLyoqXG4gKiBHZXQgdGhlIGNsYXNzTmFtZSBvZiBhIGBUYWJsZS5FZGl0YWJsZUNlbGxgLlxuICogQHBhcmFtIHtzdHJpbmd9IGFwcGVhcmFuY2VcbiAqIEByZXR1cm4ge3N0cmluZ30gdGhlIGFwcGVhcmFuY2UgY2xhc3MgbmFtZS5cbiAqL1xuZXhwb3J0IGRlZmF1bHQgbWVtb2l6ZUNsYXNzTmFtZShnZXRBcHBlYXJhbmNlKVxuIl19